import { render, staticRenderFns } from "./FieldBranch.vue?vue&type=template&id=3ca7622e&scoped=true"
import script from "./FieldBranch.vue?vue&type=script&lang=js"
export * from "./FieldBranch.vue?vue&type=script&lang=js"
import style0 from "./FieldBranch.vue?vue&type=style&index=0&id=3ca7622e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7622e",
  null
  
)

export default component.exports